export interface FeatureBadge {
  id: string;
  label: string;
  icon: string;
  tooltip: string;
}

export const FEATURE_BADGES: FeatureBadge[] = [
  {
    id: "complementaire",
    label: "Complémentaire à toutes les assurances & formules",
    icon: "/assets/pack-zero-franchise/shield-check.svg",
    tooltip: "Compatible avec tous les assureurs et toutes les formules, du tiers au tous risques.",
  },
  {
    id: "sans-changer",
    label: "Sans changer de contrat",
    icon: "/assets/pack-zero-franchise/contract.svg",
    tooltip:
      "Votre assurance principale ne change pas. Le Pack Zéro Franchise vient simplement en complément.",
  },
  {
    id: "moins-3-min",
    label: "Couvert en moins de 3 minutes",
    icon: "/assets/pack-zero-franchise/lightning.svg",
    tooltip:
      "Renseignez vos informations, souscrivez en quelques clics et rejoignez plus de 1,5 million de membres Roole.",
  },
  {
    id: "vehicule",
    label: "S’adapte au changement de véhicule",
    icon: "/assets/pack-zero-franchise/car.svg",
    tooltip:
      "Vous changez de voiture ? Contactez le service client Roole pour transférer vos garanties sur votre nouveau véhicule.",
  },
];
